$(document).ready(function() {

    /* globale Variablen */

    var $form = $('#ttg_veranstaltungen_new form');
    var $resultContainer = $('#ttg_eventResults');
    var $loading = $resultContainer.find('.loading');
    var $nothingFound = $resultContainer.find('.nothingFound');
    var limit = parseInt($form.find('input[name="limit"]').val());
    var $masonry;
    var masonryActive = false;
    var $loadMore = $resultContainer.find('.loadMore');
    var $loadMoreWrapper = $loadMore.parent();
    var infiniteScrolling = $loadMoreWrapper.hasClass('infinite');




    /* Helper */

    var activeListStyle = function() {

        var listStyle = $('#ttg_displayOptions ul .active').data('liststyle');
        $('#ttg_eventResults').addClass(listStyle);

        return listStyle;

    };

    var isBreakpoint = function(alias) {

        return $('.device-' + alias).is(':visible');

    };





    /* Befülle Formular und qParam Handling */

    var getFormOptions = function() {
        getRegions();
        getCities();
        getCategories();
    };

    var getRegions = function() {

        var $select = $form.find('#qString_area');
        if ($select.length) {
            $.ajax({
                method: 'POST',
                url: window.location.protocol + "//" + window.location.host + "/?type=2090",
                data: {
                    experience: $form.find('input[name="experience"]').val(),
                    type: 'Area',
                    template: $form.find('input[name="template"]').val(),
                    sort: 'title asc',
                    mkt: $form.find('input[name="mkt"]').val()
                },
                dataType: 'jsonp',
                beforeSend: function() {
                    $select.empty().append('<option value="">' + $select.attr('placeholder') + '</option>');
                },
                success: function(response) {
                    $.each(response.items, function(i, category) {
                        var $option = $('<option />');
                        $option.text(category.title);
                        $select.append($option);
                    });
                }
            });
        }

    };

    var getCities = function(area) {

        var $select = $form.find('#qString_city');
        if ($select.length) {
            $.ajax({
                method: 'POST',
                url: window.location.protocol + "//" + window.location.host + "/?type=2090",
                data: {
                    experience: $form.find('input[name="experience"]').val(),
                    type: 'City',
                    template: $form.find('input[name="template"]').val(),
                    q: (area) ? 'area:"' + area + '"' : '',
                    sort: 'title asc',
                    mkt: $form.find('input[name="mkt"]').val()
                },
                dataType: 'jsonp',
                beforeSend: function() {
                    $select.empty().append('<option value="">' + $select.attr('placeholder') + '</option>');
                },
                success: function(response) {
                    $.each(response.items, function(i, city) {
                        var $option = $('<option />');
                        $option.text(city.title);
                        $.each(city.attributes, function(i, attr) {
                            if (attr.key === 'GEMKZF') {
                                // console.log(attr.value);
                                $option.attr('value', attr.value);
                            }
                        });
                        $select.append($option);
                    });
                }
            });
        }

    };

    var getCategories = function() {

        var $select = $form.find('#qString_category');
        if ($select.length) {
            // Facetten aus META-Call
            // $.ajax({
            //   method: 'POST',
            //   url: window.location.protocol + "//" + window.location.host + "/?type=2090",
            //   data: {
            //     experience: $form.find('input[name="experience"]').val(),
            //     type: 'Event',
            //     template: $form.find('input[name="template"]').val(),
            //     facets: true,
            //     limit: 1,
            //     sort: 'title asc',
            //     mkt: $form.find('input[name="mkt"]').val()
            //   },
            //   dataType: 'jsonp',
            //   beforeSend: function(){
            //     $select.empty();
            //     // .append('<option value="">'+ $select.attr('placeholder') +'</option>');
            //   },
            //   success: function( response ){
            //     $.each(response.facetGroups, function( i, facetGroup ){
            //       if( facetGroup.field === 'category' ){
            //         var facets = facetGroup.facets.sort(function(a,b) {return (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0);} ); // inkl. Sorting
            //         $.each(facets, function( i, facet ){
            //           var $option = $('<option />');
            //           $option.prop('value',facet.value).text(facet.label);
            //           $select.append($option);
            //         });
            //       }
            //     });
            //     $select.chosen({
            //       no_results_text: $select.data('lang-nocategoryfoundfor'),
            //       width: '100%',
            //       search_contains: true,
            //       display_selected_options: false
            //       // include_group_label_in_selected: true,
            //       // hide_results_on_select: true
            //     });
            //   }
            // });

            // Select aus HTML mit Chosen bearbeiten
            $select.chosen({
                no_results_text: $select.data('lang-nocategoryfoundfor'),
                width: '100%',
                search_contains: true,
                display_selected_options: false,
                max_selected_options: 30
                // include_group_label_in_selected: true
                // hide_results_on_select: true
            });

        }

    };

    var qParamGenerator = function() {

        var qParams = [];

        if ($form.find('#qString_title').val() !== '') {
            qParams.push($form.find('#qString_title').val().replace('&', ''));
        }
        // if (($form.find('#qString_area').length && $form.find('#qString_area').val() !== '') && ($form.find('#qString_city').length && $form.find('#qString_city').val() == '')) {
        if (($form.find('#qString_area').length && $form.find('#qString_area').val() !== '')) {
            qParams.push('area:"' + $form.find('#qString_area').val() + '"');
        }
        if ($form.find('#qString_city').length && $form.find('#qString_city').val() !== '') {
            qParams.push('attribute_GEMKZF:"' + $form.find('#qString_city').val() + '"');
        }
        if ($form.find('#qString_zip').length && $form.find('#qString_zip').val() !== '') {
            qParams.push('zip:' + $form.find('#qString_zip').val());
        }
        if ($form.find('#qString_category').length && $form.find('#qString_category').val() !== '' && $form.find('#qString_category').val() !== null) {
            qParams.push('category:("' + $form.find('#qString_category').val().join('" OR "') + '")');
        }
        // Vorfilter Handling
        if ($form.find('#qString_category_preFiltering').length && ($form.find('#qString_category').val() === '' || $form.find('#qString_category').val() === null)) {
            qParams.push('category:("' + $form.find('#qString_category_preFiltering').val().join('" OR "') + '")');
        }
        // if( $form.find('#qString_sorting').val()  !== '' ){ qParams.push( 'sorting:'+ $form.find('#qString_sorting').val() +'"' )  }
        if ($form.find('input[name="q"]').data('dataquality') != "") {
            qParams.push('rating_DataQuality:[' + $form.find('input[name="q"]').data('dataquality') + ' TO 100]');
        }
        if ($form.find('input[name="q"]').data('vorfilter') != "") {
            qParams.push($form.find('input[name="q"]').data('vorfilter'));
        }
        if ($form.find('input[name="q"]').data('filtertop') != "") {
            qParams.push('feature:' + $form.find('input[name="q"]').data('filtertop'));
        }

        $form.find('input[name="q"]').val(qParams.join(" AND "));

    };

    getFormOptions();

    $form.find('#qString_area').change(function(e) {
        var selectedVal = $(this).find('option:selected').val();
        getCities(selectedVal);
    });

    var minDate = new Date(); // Standard = heute
    var startZeit = moment().format('HH:mm:ss');
    // wenn im Plugin explizit ein Startdatum gesetzt wurde
    if ($form.find('#qString_ab').data('startdate')) {
        minDate = new Date($form.find('#qString_ab').data('startdate'));
        startZeit = "00:00:00";
    }
    $form.find('#qString_ab').datepicker({
        minDate: minDate,
        maxDate: '+2y',
        firstDay: 1,
        dateFormat: 'dd.mm.yy',
        altField: $('input[name="startdate"]'),
        altFormat: "yy-mm-ddT" + startZeit + "+01:00"
    })
        .datepicker("setDate", minDate)
        .next('i').click(function(e) {
            $(this).prev('input').focus();
        });



    /* Lade Events & verarbeite Response */

    var loadEvents = function(e, mode) {

        if (e.type && (e.type === 'click' || e.type === 'submit')) {
            e.preventDefault();
        }

        var dpAbDate = new Date($('#qString_ab').datepicker("getDate")).getTime();

        // Enddate Befüllung sofern Relevanzsortierung
        if ($form.find('#sort').val() === "rating_Relevanz_41 desc, title asc") {
            var dayPlus2Weeks = new Date(dpAbDate + 1209600000); // 2 Wochen
            var month2 = (dayPlus2Weeks.getMonth() < 9) ? '0' + (dayPlus2Weeks.getMonth() + 1) : (dayPlus2Weeks.getMonth() + 1);
            var day2 = (dayPlus2Weeks.getDate() < 10) ? '0' + dayPlus2Weeks.getDate() : dayPlus2Weeks.getDate();
            $('#enddate').val(dayPlus2Weeks.getFullYear() + '-' + month2 + '-' + day2 + 'T00:00:00+01:00');
        } else {
            $('#enddate').val('3000-12-31T00:00:00+01:00');
        }

        if ($form.find('#sort').val() === "distance asc, start asc") {
            if (getHashParameter('latlon').length > 0) {
                latlon = getHashParameter('latlon');
                $('#lat').val(latlon.split(',')[0]);
                $('#lon').val(latlon.split(',')[1]);

                var dayPlus8Weeks = new Date(dpAbDate + 4838400000); // 8 Wochen
                var month8 = (dayPlus8Weeks.getMonth() < 9) ? '0' + (dayPlus8Weeks.getMonth() + 1) : (dayPlus8Weeks.getMonth() + 1);
                var day8 = (dayPlus8Weeks.getDate() < 10) ? '0' + dayPlus8Weeks.getDate() : dayPlus8Weeks.getDate();
                $('#enddate').val(dayPlus8Weeks.getFullYear() + '-' + month8 + '-' + day8 + 'T00:00:00+01:00');
            }
        }

        var layoutTimeout = (activeListStyle() === 'kacheln') ? 500 : 0; // Timeout benötigt für Rendering

        $.ajax({
            method: 'POST',
            url: window.location.protocol + "//" + window.location.host + "/?type=2090",
            data: $form.serialize(),
            dataType: 'jsonp',
            beforeSend: function() {

                $loading.fadeIn();
                $loadMore.hide();
                $loadMoreWrapper.addClass('loading');
                $resultContainer.addClass('picLoadingIndication');
                $nothingFound.hide();

                if (mode === 'reset') {
                    $resultContainer.find('ul').fadeOut(400, $resultContainer.find('ul').remove());
                    masonryActive = false;
                }

            },
            success: function(response) {

                if (response.overallcount > 0) {

                    var $result = resultHtml(response); // HTML ohne Listen-/Kachelklassen
                    var $resultWithListstylesUl = createColClasses($result, mode);
                    var $resultWithListstylesLi = $resultWithListstylesUl.find('li');

                    switch (mode) {

                        case 'reset':
                        default:

                            $resultContainer.prepend($resultWithListstylesUl);
                            break;

                        case 'append':

                            $resultContainer.find('ul').append($resultWithListstylesLi);

                            if (activeListStyle() === 'kacheln' && !isBreakpoint('xs') && !isBreakpoint('sm')) {

                                setTimeout(function(e) {
                                    $masonry.masonry('appended', $resultWithListstylesLi);
                                }, layoutTimeout);

                            }

                            break;

                    }

                }

            },
            complete: function(jqXHR) {

                if (infiniteScrolling) {
                    $loadMoreWrapper.addClass('active');
                }

                if (mode === 'reset' || activeListStyle() === 'liste') {
                    $resultContainer.find('li').addClass('visible');
                }

                if (activeListStyle() === 'liste' || (isBreakpoint('xs') || isBreakpoint('sm'))) {
                    $loading.fadeOut();
                    $resultContainer.removeClass('picLoadingIndication');
                }

                if (activeListStyle() === 'kacheln') {

                    setTimeout(function(e) {
                        $resultContainer.find('li').addClass('visible');
                        if (mode === 'reset') {
                            createMasonry();
                        }
                        $loading.fadeOut();
                    }, layoutTimeout);

                    fixMasonryLayout();

                }

                setTimeout(function(e) {

                    if ($resultContainer.find('li:not(.clearfix)').length < jqXHR.responseJSON.overallcount) {
                        $loadMore.fadeIn();
                    }

                    if (jqXHR.responseJSON.overallcount < 1) {

                        $resultContainer.find('.nothingFound').fadeIn();

                    }

                    $loadMoreWrapper.removeClass('loading');

                }, layoutTimeout);

            }
        });

    };

    var fixMasonryLayout = function() { // Erzeugt das Masonry Layout nach einer fixen Zeitspanne nochmals "neu" (falls Bilder länger geladen wurden und dadurch Positionierungsfehler auftreten, werden Diese dadurch behoben - hat schon alles gepasst merkt der User Nichts davon)
        if (!isBreakpoint('xs') && !isBreakpoint('sm')) {

            setTimeout(function(e) {
                $masonry.masonry('layout');
                $resultContainer.removeClass('picLoadingIndication');
            }, 2500);

        }

    };

    var resultHtml = function(response) {

        var date = new Date();
        var eventStatusTransKey = '';
        var eventStatus = '';
        var fancyDate = function(zahl) {
            var fancyDate = (parseInt(zahl) < 10) ? '0' + zahl : zahl;
            return fancyDate;
        };

        var $ul = $('<ul class="row"></ul>');

        $.each(response.items, function(i, event) {

            var fixtureCount, nextStart, nextEnd, lastStart; // venueCount
            $.each(event.attributes, function(i, attribute) {
                switch (attribute.key) {
                    case 'interval_match_count':
                        fixtureCount = parseInt(attribute.value);
                        break;
                    // sinnlos
                    // case 'VenueCount':
                    //     venueCount = parseInt(attribute.value);
                    //     break;
                    case 'interval_first_match_start':
                        nextStart = new Date(attribute.value + ':00');
                        break;
                    case 'interval_first_match_end':
                        nextEnd = new Date(attribute.value + ':00');
                        break;
                    case 'LastFixtureStart':
                        lastStart = new Date(attribute.value + ':00');
                        break;
                    case 'Status':
                        eventStatusTransKey = attribute.value;
                        break;
                }
            });
            var actual = (date >= nextStart) ? true : false;

            var $li = $('<li class="event"></li>');

            $.each(event.keywords, function(i, keyword) {
                if (keyword === 'Top (Region)' && $resultContainer.data('top-region') == "1") {
                    $li.addClass('highlight');
                }
                if (keyword === 'Top (Bundesland)' && $resultContainer.data('top-bundesland') == "1") {
                    $li.addClass('highlight');
                }
                if (keyword === 'Top (Markendestination)' && $resultContainer.data('top-markendestination') == "1") {
                    $li.addClass('highlight');
                }
            });


            var $boxHolder = $('<a class="eventID_' + event.id + ' boxHolder" href="javascript:void(0)"></a>');

            var img = false;
            var titleCopyright = false;
            var copyright = false;
            var alt = false;
            $.each(event.media_objects, function(i, mObject) {
                if (mObject.rel === 'default') {
                    img = mObject.url;
                    alt = mObject.value;
                    if (mObject.source) {
                        titleCopyright = alt + " (&copy; " + mObject.source + ")";
                        copyright = "&copy; " + mObject.source;
                    }
                }
            });

            var $img = $('<span class="pic"><img src="//cdn.ttg.at/fileadmin/templates/global/images/rebrush/dummy_pics/veranstaltung_dummy.jpg" alt="" class="default"></span>');
            if (img) {
                $img = $('<div class="pic">');
                if (copyright) {
                    $img.append($('<div class="ttgCopyright"><div class="ttgCopyrightIcon">&copy;</div><div class="ttgCopyrightText">' + copyright + '<button><span class="fas fa-times" aria-hidden="true"></span></button></div></div>'));
                }
                $img.append($('<img src="' + img.replace('/original/', '/ltoDetailpic/') + '" alt="' + alt + '" title="' + titleCopyright + '"></div>'));
            }
            $boxHolder.append($img);

            var $contentHolder = $('<div class="contentHolder"></div>');

            if (eventStatusTransKey != '' && eventStatusTransKey != 'scheduled') {
                eventStatus = $resultContainer.data('lang-' + eventStatusTransKey) + ': ';
            }
            var $h3 = $('<h3><span>' + eventStatus + event.title + '</span></h3>');
            $contentHolder.append($h3);
            eventStatus = '';

            var $dateTime = $('<p class="dateTime"></p>');

            var $dateString = $('<span class="date" />');

            // > JETZT
            //
            //   > ENDE HEUTE || "Jetzt, bis 18:00"
            //     > GANZTÄGIG || "Jetzt, ganztägig"
            //   > ENDET ZUKUNFT || "Jetzt, bis 15.03.2018 - 18:00"
            //     > GANZTÄGIG TOURDATA FIX || "Jetzt, ganztägig" // = ENDE HEUTE GANZTÄGIG
            //
            // > ZUKUNFT
            //
            //   > HEUTE || "Heute, 18:00"
            //   > ZUKUNFT || "15.03.2018 - 18:00"
            var nowMonth = date.getMonth() + 1;
            var nowString_date = date.getDate() + '.' + nowMonth + '.' + date.getFullYear();

            var nextStartMonth = nextStart.getMonth() + 1;
            var nextStartString_date = nextStart.getDate() + '.' + nextStartMonth + '.' + nextStart.getFullYear();
            var nextStartString_time = fancyDate(nextStart.getHours()) + ':' + fancyDate(nextStart.getMinutes());

            var nextEndMonth = nextEnd.getMonth() + 1;
            var nextEndString_date = nextEnd.getDate() + '.' + nextEndMonth + '.' + nextEnd.getFullYear();
            var nextEndString_time = fancyDate(nextEnd.getHours()) + ':' + fancyDate(nextEnd.getMinutes());

            // JETZT > Event hat bereits begonnen
            if (actual) {

                // $dateString.text( $resultContainer.data('lang-jetzt')+', ' );
                $dateString.text($resultContainer.data('lang-heute') + ', ');
                // $dateString.text( 'Jetzt, ' );

                // JETZT & ENDET HEUTE
                if (nowString_date === nextEndString_date) {

                    // JETZT & GANZTÄGIG > startet um 00:00 & endet Mitternacht
                    if (nextStartString_time === '00:00' && nextEndString_time === '23:59') {

                        $dateString.append($resultContainer.data('lang-ganztaegig'));

                    }

                    // JETZT & NICHT GANZTÄGIG > endet vor Mitternacht
                    else {

                        $dateString.append($resultContainer.data('lang-bis') + ' ' + nextEndString_time);

                    }

                }

                // JETZT & ENDET NICHT HEUTE
                else {

                    if (nextStartString_time === '00:00' && nextEndString_time === '00:00') { // fix für Tourdata ganztägig Ausgabe (=endet am selben Tag 23:59)
                        $dateString.append($resultContainer.data('lang-ganztaegig'));

                    } else {

                        $dateString.append($resultContainer.data('lang-bis') + ' ' + nextEndString_date + ' - ' + nextEndString_time);

                    }

                }

            }

            // ZUKÜNFTIGES EVENT
            else {

                // STARTET NOCH HEUTE
                if (nowString_date === nextStartString_date) {

                    $dateString.text($resultContainer.data('lang-heute') + ', ');
                    $dateString.append(nextStartString_time);

                }

                // STARTET NICHT MEHR HEUTE
                else {

                    $dateString.append(nextStartString_date + ' - ' + nextStartString_time);

                }

            }

            $dateTime.append($dateString);

            if (fixtureCount > 1) { // weitere Termine Link
                $dateTime.append('<span class="weitere"><span class="eventID_' + event.id + '" href="" class="weitereTermine">&raquo; ' + $resultContainer.data('lang-weitere') + '</span></span>');
            }

            $contentHolder.append($dateTime);


            var $locationCity = $('<p class="locationCity"></p>');

            $.each(event.texts, function(i, text) { // Veranstaltungsort(e)
                if (text.rel === 'venues') {
                    $locationCity.append($('<span class="location">' + text.value + '</span>'));
                }
            });
            // if (venueCount <= 1) { // Zeige Ortsinformation nur wenn nur 1 Ort
            //     $locationCity.append($('<span class="city">' + event.zip + ' ' + event.city + '</span>'));
            // }

            $contentHolder.append($locationCity);


            $boxHolder.append($contentHolder);

            $li.append($boxHolder);

            $ul.append($li);

            getDetailLink(event);

        });

        return $ul;

    };

    var getDetailLink = function(event) {

        $.ajax({
            method: 'POST',
            url: "/index.php?type=1830",
            // GET params only for identification in devTools
            data: {
                // t3 typeNum
                tourdataId: event.id,
                tourdataTitle: event.title,
                pageUid: $('#ttg_veranstaltungen_new').data('pid'),
                sysLanguageUid: $("#ttg_veranstaltungen_new").data('syslanguageuid')
            },
            beforeSend: function(xhr, o) {

            },
            success: function(response, status, xhr) {
                $('.eventID_' + event.id).attr('href', $.trim(response));

                var latlon;
                if (getHashParameter('latlon').length > 0) {
                    latlon = getHashParameter('latlon');
                    $('.eventID_' + event.id).attr('href', $.trim(response) + "#latlon=" + latlon);
                }
            },
            error: function(xhr, status, error) {

            },
            complete: function(xhr, status) {


            }
        });

        //return $resultContainer.data('urlpath') + '/' + event.id + '/' + title + suffix;

    };

    var slugify = function(text) {

        return text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
            .replace(/[^\w\-]+/g, '') // Remove all non-word chars
            .replace(/\-\-+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, ''); // Trim - from end of text
    };

    var createMasonry = function() {

        if (!isBreakpoint('xs') && !isBreakpoint('sm')) {

            $masonry = $resultContainer.find('ul').masonry({
                itemSelector: 'li'
            });
            masonryActive = true;

        }

    };

    var resetClasses = function($ul, mode) {

        if (masonryActive && mode === 'reset') {
            $masonry.masonry('destroy');
            masonryActive = false;
        }
        $ul.find('li').removeClass('col-md-3 col-md-4 col-md-5 col-md-6 col-md-offset-2');
        $ul.find('li.clearfix').remove();
        $ul.find('.row').removeClass('row'); // !!! ev. Ebene höher
        $ul.find('.col-xs-3').removeClass('col-xs-3');
        $ul.find('.col-xs-9').removeClass('col-xs-9');
        $ul.find('.col-xs-12').removeClass('col-xs-12');

    };

    var createColClasses = function($ul, mode) {

        resetClasses($ul, mode);

        var $li = $ul.find('li');
        var colsClass;

        if (activeListStyle() === 'kacheln') {

            colsClass = 'col-md-' + $resultContainer.data('kachelcols');

        } else {

            colsClass = 'col-md-' + $resultContainer.data('liststyle');

            // Clearfix & padding in Liste
            var $clearfix = $('<li />').addClass('clearfix');
            $ul.find('li:odd').each(function(e) {
                $clearfix.clone().insertAfter($(this));
                if (colsClass == 'col-md-5') {
                    $(this).addClass('col-md-offset-2');
                }
            });

            $li.find('.boxHolder').addClass('row').each(function(e) {
                $(this).find('.pic').addClass('col-xs-3');
                if ($(this).find('.col-xs-3').length) {
                    $(this).find('.contentHolder').addClass('col-xs-9');
                } else {
                    $(this).find('.contentHolder').addClass('col-xs-12');
                }
            });

        }

        $li.addClass(colsClass);

        return $ul;

    };





    /* Actions */

    if (isBreakpoint('xs') || isBreakpoint('sm')) {

        $('#ttg_veranstaltungen_new').addClass('mobileMode');

        // On mobile - automatic Kachelmode
        // RESET
        $('#ttg_displayOptions').find('ul').find('li a').removeClass('active');

        // ACTIVE LAYOUT
        $('#ttg_displayOptions').find('ul').find('a[data-liststyle="kacheln"]').addClass('active');
        $resultContainer.removeClass('kacheln').removeClass('liste').addClass(activeListStyle());
        var resultWithListstylesUl = createColClasses($resultContainer.find('ul'), 'reset');

    }

    $form.submit(function(e) {
        $loadMore.hide();
        $('input[name="offset"], input[name="actualCount"]').val(0);
        qParamGenerator();
        loadEvents(e, 'reset');
    });

    var loadMore = function(e) {
        $('input[name="offset"]').val(parseInt($('input[name="offset"]').val()) + limit);
        loadEvents(e, 'append');
    };

    // load More nach Click
    $loadMore.click(loadMore);

    var scrollMagicCtrl, scene;

    // Load More Infinite
    // Eigener Offset für Terminal
    if (infiniteScrolling && $('.ttg-tdterminal')) {
        scrollMagicCtrl = new ScrollMagic.Controller();
        scene = new ScrollMagic.Scene({
            triggerElement: '.loadMoreWrapper.infinite',
            offset: -1200
        }).addTo(scrollMagicCtrl).on('enter', function(e) {
            // console.log( $loadMore.is(':visible') );
            if (!$loadMoreWrapper.hasClass('active')) {
                $form.submit(); // initiales Laden von Events bei aktiviertem Infinite Scrolling
            } else {
                if (!$loadMoreWrapper.hasClass('loading') && $loadMore.is(':visible')) {
                    loadMore(e);
                }
            }
        });
    } else if (infiniteScrolling) {
        scrollMagicCtrl = new ScrollMagic.Controller();
        scene = new ScrollMagic.Scene({
            triggerElement: '.loadMoreWrapper.infinite',
            offset: -380
        }).addTo(scrollMagicCtrl).on('enter', function(e) {
            // console.log( $loadMore.is(':visible') );
            if (!$loadMoreWrapper.hasClass('active')) {
                $form.submit(); // initiales Laden von Events bei aktiviertem Infinite Scrolling
            } else {
                if (!$loadMoreWrapper.hasClass('loading') && $loadMore.is(':visible')) {
                    loadMore(e);
                }
            }
        });
    } else {
        $form.submit(); // initiales Laden von Events bei Laden auf Click
    }

    $form.find('#sort').change(function() {
        $form.submit();
    });

    $('#ttg_displayOptions a').click(function(e) {

        e.preventDefault();
        var ul = $(this).closest('ul');

        // RESET
        ul.find('li a').removeClass('active');

        // ACTIVE LAYOUT
        $(this).addClass('active');
        $('#ttg_eventResults').removeClass('kacheln').removeClass('liste').addClass(activeListStyle());
        var resultWithListstylesUl = createColClasses($resultContainer.find('ul'), 'reset');

        if (activeListStyle() === 'kacheln') {
            createMasonry();
        }

    });

});



/* TODO

  (.) Lokalisierung
    (x) Kategorienfilter
    (x) Tourdata Ergebnisse
    (.) Template
      (x) DE
      (x) EN
      ( ) weitere Sprachen (NL, IT, CS, PL)
    (x) LinkURLs
  (x) Highlighting
    (x) Top Region, TOP Bundesland, TOP Markendestination > wartbar über Plugin Settings
  (x) Datum übergeben
  (x) Infinite Scrolling
  (x) Flexform Einstellungen
  (x) Detailverlinkung
    (x) über Pagepath & embed URL > ???
  (x) Nothing Found Handling
  (x) Sortierung
    (x) Optionen
    (x) Results
  (x) Datumsanzeigen (OOEAT-958 > bei Michael)
  (x) Filterung nach Orten (OOEAT-958 > bei Michael)
  (.) Sortierung
    ( ) Korrekt nach Datum (liegt bei Hary)
    (x) Korrekt nach Relevanz
  (x) Vorfilterung
    (x) Prolem mit max-length of GET-Params

*/